import { render, staticRenderFns } from "./NpaAnswers.vue?vue&type=template&id=195eb827&scoped=true&"
import script from "./NpaAnswers.vue?vue&type=script&lang=js&"
export * from "./NpaAnswers.vue?vue&type=script&lang=js&"
import style0 from "./NpaAnswers.vue?vue&type=style&index=0&id=195eb827&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195eb827",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VFileInput,VList,VListItem,VListItemTitle,VMenu})
